export default __webpack_public_path__ + "static/media/LOGO_contruyendo_header_color.2bd57183.png";